import { PCImage } from 'app/design/primitives/image';
import { ChannelRow } from './channel';

import type { ListingChannel as ListingChannelType } from 'app/types/chat';

import { TutorialRef } from 'app/types/tutorial';
import { useTutorialRef } from 'app/components/tutorial-overlay';
import { isRequestIcon } from 'app/lib/is-request-icon';
import { RequestImage } from 'app/components/request-image';

import { StatusBadge } from 'app/components/listing-request-card';
import { ListingType } from 'app/types/listing';
import { useGetInterlocutor } from 'app/network/chat';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

const ListingChannel = function ListingChannel({
  isFirstConcierge,
  useInterlocutorPicture = false,
  ...channel
}: ListingChannelType & { isFirstConcierge?: boolean; useInterlocutorPicture?: boolean }) {
  const { viewRef } = useTutorialRef(isFirstConcierge ? TutorialRef.FirstConciergeChat : undefined);
  const getInterlocutor = useGetInterlocutor();
  const interlocutorPicture = getInterlocutor(channel)?.profile_url;
  const picture = useInterlocutorPicture && interlocutorPicture ? interlocutorPicture : channel.picture;

  const statusBadge =
    channel.listing?.hasLender && channel.listing.type === ListingType.request ? (
      <StatusBadge
        end={channel.listing.end}
        start={channel.listing.start}
        hideDates
        badgeBg={theme.colors['text.success']}
        cardStatus="found"
        before={undefined}
        hideListingsSubtype
      />
    ) : null;

  return (
    <ChannelRow
      innerRef={viewRef}
      channel={channel}
      statusBadgeContent={statusBadge}
      prefix={
        isRequestIcon(picture) ? (
          <RequestImage
            style={{
              borderWidth: channel.listing?.hasLender ? 2 : 0,
              borderColor: channel.listing?.hasLender ? theme.colors['text.success'] : undefined,
            }}
            width={60}
            height={60}
            isFound={!!channel.listing?.hasLender}
          />
        ) : (
          <PCImage
            aspectRatio={1}
            height={60}
            source={{ uri: picture }}
            style={{
              borderRadius: theme.borderRadii['radius.full'],
            }}
          />
        )
      }
    />
  );
};

export { ListingChannel };
